const theme = {
  palette: {
    primary: '#C20D19',
    gray: {
      50: '#e6e6e6',
      100: '#cccccc',
      200: '#4d4d4d',
      300: '#212121',
    },
    success: '#29a33f',
    warning: '#F3CF0F',
    error: '#CB4939',
  },
}

export default theme
